import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function SearchIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.1853 12.6115C10.0179 13.4836 8.56927 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7C14 8.56927 13.4836 10.0179 12.6115 11.1853L15.7046 14.2785C16.0985 14.6723 16.0985 15.3108 15.7046 15.7046C15.3108 16.0985 14.6723 16.0985 14.2785 15.7046L11.1853 12.6115ZM12 7C12 9.76142 9.76142 12 7 12C4.23858 12 2 9.76142 2 7C2 4.23858 4.23858 2 7 2C9.76142 2 12 4.23858 12 7Z"
        />
      </svg>
    </Icon>
  );
}
